import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import authReducer from './slices/authSlice'
import tableReducer from './slices/tableSlice'
import { adminApi } from './api/adminApi'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tables: tableReducer,
    [adminApi.reducerPath]: adminApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(adminApi.middleware),
})

// Required for per-query `refetchOnFocus` / `refetchOnReconnect` to do anything.
// Without it the support queue silently goes stale while an admin sits on it.
// Opt-in per query — no endpoint refetches globally by default.
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
